import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'skl-select-option',
    template: `
    <div class="select-option">
        <i class="icon-circle-empty text--info align--medium-right" [ngClass]="{'icon-circle-inner' : bindTo === selectedOption}"></i>
        <span> {{label}} </span>
    </div>
    `,
    styles: [`
        .select-option {
            cursor: pointer;
        }
    `],
    imports: [NgClass]
})
export class SelectOptionComponent {
    @Input() public bindTo: any;
    @Input() public label!: string;
    @Input() public selectedOption: any;
}
